import { module, bootstrap } from "angular";
// import sportIconDirective from "../../partials/sport-icon/sport-icon.directive";
// import teamIconDirective from "../../partials/icons/team-icon/team-icon.directive";
// import { MatchService } from "../../services/match.service";
import { SportDataService } from "../../services/sport-data.service";
import { addGTMTag, generalConfig, /*rollbarConfig*/ } from "../general";
import "./new-best-promos.scss";
// import flagIconDirective from "../../partials/icons/flag-icon/flag-icon.directive";
import { nthFilter } from "../../filters/nth.filter";
import { GeneralService } from "../../services/general.service";
// import { BetService } from "../../services/bet.service";
import { BlockConfigurationObject } from "../../interfaces/block-configuration-object.interface";
import newBestPromosBlockComponent from "./new-best-promos.component";

function loadSingleSiNewBestPromos(config: BlockConfigurationObject): Promise<void> {
	return new Promise((resolve, reject) => {
		// remove case-sensitivity for state code
		// config.stateCode = config.stateCode.toUpperCase();
		// determine target element
		if (!config.targetElementID) {
			config.targetElementID = "si-external-new-best-promos";
		}
		const targetElement = document.getElementById(config.targetElementID);
		if (targetElement !== null) {
			if (config.debugMode) {
				targetElement.innerHTML = "Loading Best Promos Block...";
			}
	
			if (config.publicationTheme) {
				
				require("../../publisher-themes/" + config.publicationTheme + ".scss");
			}

			targetElement.innerHTML = "<si-external-new-best-promos></si-external-new-best-promos>";

			addGTMTag(config);

			module("siExternalNewBestPromos", [require("angular-sanitize"), /* 'ngAnimate',*/ /*require("ng-rollbar")*/])
				.value("configurationObject", config)
				.value("apiDomain", process.env.API_DOMAIN)
				.constant("blockDomain", process.env.BLOCK_DOMAIN)
				.constant("cdnDomain", process.env.CDN_DOMAIN)
				.filter("nth", nthFilter)
				.service("generalService", GeneralService)
				// .service("matchService", MatchService)
				.service("sportDataService", SportDataService)
				// .service("betService", BetService)
				// .directive("teamIconSport", teamIconDirective)
				// .directive("flagIconCountry", flagIconDirective)
				// .directive("sportIconCode", sportIconDirective)
				.config(generalConfig)
				.component("siExternalNewBestPromos", newBestPromosBlockComponent)
				// .config(["RollbarProvider", rollbarConfig]);

			bootstrap(targetElement, ["siExternalNewBestPromos"], {strictDi: true});

			resolve();

		} else {
			reject(`Target element (#${config.targetElementID}) not found`);
		}
	});
}

function loadSiNewBestPromos(config: BlockConfigurationObject): Promise<void> {
	return new Promise((resolve, reject) => {
		console.log("SI Loader script called");
		if (config) {
			if (Array.isArray(config)) {
				config.reduce((previousPromise, nextConfig) => {
					return previousPromise.then(() => {
						return loadSingleSiNewBestPromos(nextConfig);
					}, (err) => {
						console.error("Best Promos Block failed: " + err);
						return loadSingleSiNewBestPromos(nextConfig);
					});
				}, Promise.resolve()).then(resolve);
			} else {
				loadSingleSiNewBestPromos(config).then(() => {
					console.log("Best Promos Block Successfully Loaded");
					resolve();
				}, (err) => {
					console.log(`Best Promos Block failed: ${err}`);
					reject(`Best Promos Block failed: ${err}`);
				});
			}
		} else {
			console.log("Configuration object (config) not found");
			reject("Configuration object (config) not found");
		}
	});
}

if (typeof window !== undefined) {
	window["loadSiNewBestPromos"] = loadSiNewBestPromos;
}
export { loadSiNewBestPromos as loadSiNewBestPromos };